export default __webpack_public_path__ + "static/media/instagram-img3.16e17289.jpg";